import { Validators } from '@quickbit/qb-design-system';
import { CreatePaymentForm } from '../Payments/CreatePayment';

export const paymentValidators: Validators<
  CreatePaymentForm,
  CreatePaymentForm
> = {
  eurAmount: (value) => {
    if (value && value <= 0) {
      return 'Amount must be greater than 0';
    }
  },
};
